import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Row,
	Col,
	Button,
	Modal,
	Form,
	FormGroup,
	Label,
	Input,
	Card,
	CardBody,
	Spinner,
} from "reactstrap"

import { ToastContainer } from "react-toastify";
import * as url from "../../helpers/url_helper"
import PlatformList from "./PlatformList";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import 'react-toastify/dist/ReactToastify.css';

// Utilities
import {
	fetchApi,
	processDeleteResponse,
	createNotificationHelpers,
	loadPlatformsData,
	fetchPlatformTokens,
	createPlatform,
	updatePlatform,
	transformPlatformsToTableData,
	PLATFORM_TABLE_COLUMNS,
	MESSAGES
} from "../utils";

class Platform extends Component {
	constructor(props) {
		super(props)
		this.state = {
			platform: [],
			loading: false,
			modal_standard_create: false,
			modal_standard_edit: false,
			modal_standard_token: false,
			accessToken: "",
			refreshToken: "",
			userInfo: {},
			name: "",
			email: "",
			username: "",
			password: "",
			showPassword: false
		}

		this.create_platform = this.create_platform.bind(this);
		this.edit_platform = this.edit_platform.bind(this);
		this.token_platform = this.token_platform.bind(this);
		this.delete_platform = this.delete_platform.bind(this);

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_info = notifications.notify_info;
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}

	handleClick = (id, status) => {
		console.log(id, status);
	}

	togglePasswordVisibility = () => {
		this.setState((prevShowPassword) => ({
			showPassword: !prevShowPassword.showPassword
		}));
	};

	/**
	 * Loads platforms from API and updates state
	 */
	loadPlatforms = async () => {
		const platforms = await loadPlatformsData(this.notify_error);

		if (platforms) {
			const data = transformPlatformsToTableData(
				platforms,
				PLATFORM_TABLE_COLUMNS,
				this.edit_platform,
				this.token_platform,
				this.delete_platform
			);
			this.setState({ platform: data, loading: true });
			this.notify_success(MESSAGES.PLATFORM_LOADED_SUCCESS);
		}
	}

	componentDidMount() {
		this.loadPlatforms();
	}

	create_platform = () => {
		// clear state fdata 
		this.setState(prevState => ({
			userInfo: {},
			modal_standard_create: !prevState.modal_standard_create,
		}))
	}

	edit_platform = (id, name, email, username) => {
		this.setState(prevState => ({
			userInfo: {
				id: id,
				name: name,
				email: email,
				username: username
			},
			modal_standard_edit: !prevState.modal_standard_edit,
		}))
	}

	/**
	 * Fetches tokens for a platform
	 */
	token_platform = async (email) => {
		const results = await fetchPlatformTokens(email, this.notify_error);

		if (results) {
			this.setState(prevState => ({
				modal_standard_token: !prevState.modal_standard_token,
				accessToken: results?.accessToken || "",
				refreshToken: results?.refreshedToken || ""
			}));
		}
	}

	/**
	 * Deletes a platform
	 */
	delete_platform = async (id) => {
		let answer = window.confirm("Are you sure you want to delete this platform?");
		if (!answer) {
			return;
		}

		const { response, results } = await fetchApi(url.DELETE_PLATFORM, 'DELETE', { id });

		if (processDeleteResponse(
			response,
			results,
			this.notify_success,
			this.notify_error,
			MESSAGES.PLATFORM_DELETED_SUCCESS,
			MESSAGES.PLATFORM_DELETION_FAILED
		)) {
			window.location.reload();
		}
	}

	/**
	 * Updates a platform
	 */
	handleUpdatePlatform = async (e) => {
		e.preventDefault();
		const { id, name, username, password } = this.state.userInfo;

		const success = await updatePlatform({ id, name, username, password }, this.notify_error);

		if (success) {
			this.notify_success(MESSAGES.PLATFORM_UPDATED_SUCCESS);
			await new Promise(r => setTimeout(r, 5000));
			window.location.reload();
		}
	}

	/**
	 * Creates a new platform
	 */
	handlePlatformSubmit = async (e) => {
		e.preventDefault();
		const { name, email, username, password } = this.state.userInfo;

		const success = await createPlatform({ name, email, username, password }, this.notify_error);

		if (success) {
			this.notify_success(MESSAGES.PLATFORM_CREATED_SUCCESS);
			await new Promise(r => setTimeout(r, 5000));
			window.location.reload();
		}
	}

	handleInputChange = (e) => {
		this.setState({
			userInfo: {
				...this.state.userInfo,
				[e.target.name]: e.target.value
			}
		})
	}

	render() {
		const {
			loading,
			platform,
		} = this.state;

		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Platform</title>
					</Helmet>
					<Container fluid>
						{/* Render Breadcrumb */}
						<Breadcrumbs
							title={this.props.t("Platform")}
							breadcrumbItem={this.props.t("Platform")}
						/>

						<ToastContainer />
						<Row>
							<Col xl={12}>
								{loading ? (
									<React.Fragment>
										<div className="" style={{ "textAlign": "right", "paddingBottom": "10px" }}>
											<span className="loading"></span>
											<Button
												color="primary"
												className="btn btn-primary waves-effect waves-light"
												onClick={this.create_platform}
												data-toggle="modal"
												data-target="#myModal"
											>Create</Button>
										</div>
										<PlatformList customers={platform} />
									</React.Fragment>
								) : (
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
										<Spinner color="primary" />
										<span style={{ marginLeft: '10px' }}>Loading ...</span>
									</div>
								)}
							</Col>

							<Modal
								isOpen={this.state.modal_standard_create}
								toggle={this.create_platform}
							>
								<div className="modal-header">
									<h5 className="modal-title mt-0" id="myModalLabel">
										Create Platform
									</h5>
									<button
										type="button"
										onClick={() =>
											this.setState({ modal_standard_create: false })
										}
										className="close"
										data-dismiss="modal"
										aria-label="Close"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div className="modal-body">
									<Card>
										<CardBody>
											<Form onSubmit={this.handlePlatformSubmit}>
												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-firstname-Input"
														className="col-sm-4 col-form-label"
													>
														Platform Name
													</Label>
													<Col sm={8}>
														<Input
															type="text"
															name="name"
															placeholder="Platform Name"
															className="form-control"
															id="horizontal-firstname-Input"
															value={this.state?.userInfo?.name}
															onChange={this.handleInputChange}
															required
														/>
													</Col>
												</FormGroup>
												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-username-Input"
														className="col-sm-4 col-form-label"
													>
														Contact Name
													</Label>
													<Col sm={8}>
														<Input
															type="text"
															name="username"
															placeholder="Contact Name"
															className="form-control"
															id="horizontal-username-Input"
															value={this.state?.userInfo?.username}
															onChange={this.handleInputChange}
															required
														/>
													</Col>
												</FormGroup>

												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-email-Input"
														className="col-sm-4 col-form-label"
													>
														Email
													</Label>
													<Col sm={8}>
														<Input
															type="email"
															name="email"
															placeholder="Email Address"
															className="form-control"
															id="horizontal-email-Input"
															value={this.state?.userInfo?.email}
															onChange={this.handleInputChange}
															required
														/>
													</Col>
												</FormGroup>
												<FormGroup className="row justify-content-end">
													<Col sm={8}>
														<div>
															<Button
																type="submit"
																color="primary"
																className="w-md"
															>
																Submit
															</Button>
														</div>
													</Col>
												</FormGroup>
											</Form>
										</CardBody>
									</Card>
								</div>
							</Modal>

							<Modal
								isOpen={this.state.modal_standard_edit}
								toggle={this.edit_platform}
							>
								<div className="modal-header">
									<h5 className="modal-title mt-0" id="myModalLabel">
										Edit Platform
									</h5>
									<button
										type="button"
										onClick={() =>
											this.setState({ modal_standard_edit: false })
										}
										className="close"
										data-dismiss="modal"
										aria-label="Close"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>

								<div className="modal-body">
									<Card>
										<CardBody>
											<Form onSubmit={this.handleUpdatePlatform}>
												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-firstname-Input"
														className="col-sm-4 col-form-label"
													>
														Platform Name
													</Label>
													<Col sm={8}>
														<Input
															type="text"
															name="name"
															placeholder="Platform Name"
															className="form-control"
															id="horizontal-firstname-Input"
															value={this.state?.userInfo?.name}
															onChange={this.handleInputChange}
															required
														/>
													</Col>
												</FormGroup>
												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-username-Input"
														className="col-sm-4 col-form-label"
													>
														Contact Name
													</Label>
													<Col sm={8}>
														<Input
															type="text"
															name="username"
															placeholder="Contact Name"
															className="form-control"
															id="horizontal-username-Input"
															value={this.state?.userInfo?.username}
															onChange={this.handleInputChange}

															required
														/>
													</Col>
												</FormGroup>
												<FormGroup className="row mb-4">
													<Label
														htmlFor="horizontal-email-Input"
														className="col-sm-4 col-form-label"
													>
														Email
													</Label>
													<Col sm={8}>
														<Input
															type="email"
															name="email"
															placeholder="Email Address"
															className="form-control"
															id="horizontal-email-Input"
															value={this.state?.userInfo?.email}
															readOnly
														/>
													</Col>
												</FormGroup>

												<FormGroup className="row justify-content-end">
													<Col sm={8}>
														<div>
															<Button
																type="submit"
																color="primary"
																className="w-md"
															>
																Update
															</Button>
														</div>
													</Col>
												</FormGroup>
											</Form>
										</CardBody>
									</Card>
								</div>
							</Modal>

							<Modal
								isOpen={this.state.modal_standard_token}
								toggle={this.token_platform}
							>
								<div className="modal-header">
									<h5 className="modal-title mt-0" id="myModalLabel">
										Platform Token
									</h5>
									<button
										type="button"
										onClick={() =>
											this.setState({ modal_standard_token: false })
										}
										className="close"
										data-dismiss="modal"
										aria-label="Close"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div className="modal-body">
									<h5>Access Token</h5>
									<p style={{ wordWrap: "break-word" }}>
										{this.state.accessToken}
									</p>
									<h5>Refresh Token</h5>
									<p style={{ wordWrap: "break-word" }}>
										{this.state.refreshToken}
									</p>
								</div>
								<div className="modal-footer">
								</div>
							</Modal>
						</Row>
					</Container>
				</div>

			</React.Fragment >
		)

	}
}

Platform.propTypes = {
	t: PropTypes.any
}

export default withTranslation()(Platform)
